// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderTwoToneSvg from "@fishx/icons-svg/es/asn/FolderTwoTone";
import FishxIcon from '../components/FishxIcon';

var FolderTwoTone = function FolderTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderTwoToneSvg
  }));
};

FolderTwoTone.displayName = 'FolderTwoTone';
export default React.forwardRef(FolderTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderTwoTone.js
// module id = 2807
// module chunks = 0